import { z, type ZodType } from '@customerio/hydra-validation';
import type { User as UIAPIUser } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

/**
 * Account user — a member of the account. Wire shape passes through from the
 * generated `User` model; only the fields we read today are asserted at parse
 * time (others pass through via `looseObject`).
 */
export type AccountUser = UIAPIUser;

// oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
const AccountUserFromApi = z.looseObject({
  id: z.string(),
  email: z.string(),
}) as unknown as ZodType<AccountUser, unknown>;

/** @public */
export const accountUser = defineEntity<AccountUser, AccountUser, void, undefined, 'account'>({
  name: 'user',
  scope: 'account',
  pk: (user) => user.id,
  schema: { read: AccountUserFromApi },
});

export const accountUserKeys = accountUser.keys;

export function parseAccountUser(raw: UIAPIUser): AccountUser {
  return accountUser.parse(raw);
}
